<template>
  <v-card height="100%">
    <v-card-title>
      <span>{{ $t("transactions") }}</span></v-card-title
    >
    <v-card-text class="pa-0 pb-2">
      <v-progress-circular
        v-if="loading"
        class="my-4 mx-auto d-block"
        indeterminate
        color="primary"
        :size="50"
        :width="7"
      ></v-progress-circular>
      <v-list v-else dense class="py-0">
        <template v-for="(item, idx) in amountMetrics">
          <v-list-item
            :key="item.id"
            class="pb-2"
            :to="paymentsOverviewRoute(item.filterParams)"
          >
            <v-list-item-content>
              <v-list-item-title class="text-h6">
                <v-icon v-if="!isMobile" large color="black">{{
                  item.icon
                }}</v-icon>
                {{ $t(item.titleKey) }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("basedInfo", { number: item.items[0].count }) }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon class="mt-4">
              <span class="font-weight-bold text-h5 text-sm-h4">
                {{
                  currencySign +
                  " " +
                  parseFloat(item.items[0].amount).toFixed(2).toString()
                }}
              </span>
            </v-list-item-icon>
          </v-list-item>
          <v-divider
            v-if="idx < amountMetrics.length - 1"
            :key="'divider_' + idx"
          ></v-divider>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import isMobile from "@/mixins/isMobile";
import { getCurrencySign } from "@/static/currencies";

export default {
  name: "AmountsMetrics",
  mixins: [isMobile],
  props: {
    amountMetrics: {
      required: true,
      type: Array,
    },
    loading: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    currencySign() {
      if (!this.currentHotel) {
        return "";
      }
      let sign = "";
      const currencySign = getCurrencySign(this.currentHotel.currencyCode);
      if (currencySign) {
        sign = currencySign;
      }
      return sign;
    },
    ...mapState(["currentHotel"]),
  },
  methods: {
    paymentsOverviewRoute(params) {
      params.dateType = 1;
      return {
        name: "payments",
        params: params,
      };
    },
  },
};
</script>
